@if (value) {
  <div class="value">{{ value }}</div>
}
@if (to.btnStyle === 'stroked') {
  <button
    mat-stroked-button
    [color]="to.btnType || 'primary'"
    (click)="onClick()"
    [matTooltip]="to.tooltip ? (to.tooltip | translate) : ''"
  >
    {{ (to.text | translate) || 'Click Me' }}
  </button>
} @else {
  <button
    mat-flat-button
    [color]="to.btnType || 'primary'"
    (click)="onClick()"
    [matTooltip]="to.tooltip ? (to.tooltip | translate) : ''"
  >
    {{ (to.text | translate) || 'Click Me' }}
  </button>
}
